import { useEffect, useState, useMemo } from 'react';

import InvoicePdf from './InvoicePdf';
import InvoiceXml from './InvoiceXml';
import Taxes from './Taxes';

const Financial = ({
  nfRef,
  ICMSST,
  invoice,
  uploadDocument,
  fetchOrderDetail,
  orderSource,
}) => {
  const [invoicePdf, invoiceXml] = useMemo(() => [
    invoice.documents.find(doc => doc.documentType === 'NF_PDF'),
    invoice.documents.find(doc => doc.documentType === 'NF_XML'),
  ]);

  const [hasInvoicePdf, setHasInvoicePdf] = useState(!!invoicePdf);
  const [hasInvoiceXml, setHasInvoiceXml] = useState(!!invoiceXml);

  const handleSetInvoicePdf = () => {
    setHasInvoicePdf(true);
  };

  const handleSetInvoiceXml = () => {
    setHasInvoiceXml(true);
  };

  const [stateICMSST, setStateICMSST] = useState(ICMSST || 0);

  const handleAddICMSST = number => {
    setStateICMSST(number);
  };

  useEffect(() => {
    if (invoiceXml !== undefined && invoicePdf !== undefined) return;

    if (hasInvoicePdf && hasInvoiceXml) {
      fetchOrderDetail();
      window.scroll(0, 0);
    }
  }, [hasInvoicePdf, hasInvoiceXml]);

  return (
    <>
      <div className="row border-top pt-4">
        <div className="col-12">
          <h1 className="mt-2 mb-0 fw-light" ref={nfRef}>
            Nota fiscal do pedido
          </h1>
          <p className="text-secondary fs-5">
            Por favor adicione a Nota Fiscal do pedido em PDF e XML
          </p>
        </div>
      </div>
      <div className="row d-flex align-items-center justify-content-center gap-4 my-4">
        <InvoicePdf
          invoicePdf={invoicePdf}
          uploadDocument={uploadDocument}
          handleSetInvoicePdf={handleSetInvoicePdf}
        />
        <InvoiceXml
          invoiceXml={invoiceXml}
          uploadDocument={uploadDocument}
          handleSetInvoiceXml={handleSetInvoiceXml}
          setStateICMSST={handleAddICMSST}
        />
      </div>
      <Taxes nfRef={nfRef} orderSource={orderSource} ICMSST={stateICMSST} />
    </>
  );
};

export default Financial;
